import { TranslationService } from "@services/translation.service";
import * as angular from "angular";
import "./timePicker.scss";

export interface ITimePickerComponentBindings {
    hour: number;
    minute: number;

    disableControls: boolean;
    showIcon: boolean;

    labelHour: string;
    labelMinute: string;

    onTimeChanged: (args: { hour: number, minute: number }) => void;
}

class TimePickerComponentController implements angular.IComponentController, ITimePickerComponentBindings {
    hour: number;
    minute: number;

    disableControls: boolean;
    showIcon: boolean = true;

    labelHour: string;
    labelMinute: string;

    onTimeChanged: (args: { hour: number, minute: number }) => void;


    static $inject = ["translationService"];

    constructor( private readonly translationService: TranslationService) { }

    $onInit() {
        this.labelHour = this.labelHour || this.translationService.t("TimePicker.Hour");
        this.labelMinute = this.labelMinute || this.translationService.t("TimePicker.Minute");
    }

    timeChanged(): void {

        if (this.onTimeChanged) {
            this.onTimeChanged({ hour: this.hour, minute: this.minute });
        }
    }
}

export class TimePickerComponent implements angular.IComponentOptions {
    bindings: any;
    controller: any;
    template: string;

    constructor() {
        this.bindings = {
            hour: "<",
            minute: "<",
            labelHour: "<?",
            labelMinute: "<?",
            disableControls: "<?",
            showIcon: "<?",
            onTimeChanged: "&"
        };

        this.controller = TimePickerComponentController;
        this.template = require("./timePicker.html");
    }
}
